"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _numeral = _interopRequireDefault(require("numeral"));

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _constants = require("../../util/constants");

var _ActionRoot = require("../../higher-order/ActionRoot");

var _class, _class2, _descriptor, _descriptor2, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var RewardsCalculatorInput = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(RewardsCalculatorInput, _React$Component);

  var _super = _createSuper(RewardsCalculatorInput);

  function RewardsCalculatorInput(props) {
    var _this;

    _classCallCheck(this, RewardsCalculatorInput);

    _this = _super.call(this, props);

    _initializerDefineProperty(_assertThisInitialized(_this), "value", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "focused", _descriptor2, _assertThisInitialized(_this));

    _this.value = _this.parseDefaultValueFromProps(_this.props);
    return _this;
  }

  _createClass(RewardsCalculatorInput, [{
    key: "parseDefaultValueFromProps",
    value: function parseDefaultValueFromProps(props) {
      var initialValue = props.value; // inConverter for years

      if (props.yearsToMonths) {
        initialValue = Math.floor(initialValue / 12);
      }

      return Number(initialValue);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      if (e.which === _constants.KEYCODES.ENTER
      /* Enter */
      ) {
        this.input.blur();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var value = this.parseDefaultValueFromProps(this.props);

      if (!this.focused) {
        this.value = value;
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      this.focused = true;
      this.value = "";
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var dataValue;

      if (this.value === "") {
        // if nothing was entered, parse from props again
        dataValue = this.parseDefaultValueFromProps(this.props);
      } else {
        dataValue = parseFloat((0, _numeral.default)(this.value).value());
      }

      if (typeof dataValue === "number" && !isNaN(dataValue) && dataValue >= this.props.min && dataValue <= this.props.max) {
        // outConverter for years
        if (this.props.yearsToMonths) {
          dataValue *= 12;
        }

        this.context.dispatcher.emit(this.props.eventName, {
          key: this.props.inputKey,
          value: dataValue
        });
      } else {
        // user entered valid was invalid; reset
        this.value = this.props.value;
      }

      this.focused = false;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.value = e.currentTarget.value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var displayValue = this.value;

      if (!this.focused) {
        var formatString = this.props.formatString || (this.props.percentage ? "0.00" : "0,0");

        if (this.props.percentage && displayValue >= 1) {
          displayValue /= 100;
        }

        displayValue = (0, _numeral.default)(displayValue).format(formatString);
      }

      if (!(0, _isEmpty.default)(this.props.suffix)) {
        displayValue += this.props.suffix;
      }

      var refFunction = function refFunction(el) {
        return _this2.input = el;
      }; // eslint-disable-line no-return-assign


      var inputClasses = (0, _classnames.default)(this.props.inputKey, {
        disabled: this.props.disabled
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
        id: this.props.inputKey,
        ref: refFunction,
        className: inputClasses,
        onKeyPress: this.handleKeyPress,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        value: displayValue,
        disabled: this.props.disabled
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "input-background",
        "aria-hidden": "true"
      }));
    }
  }]);

  return RewardsCalculatorInput;
}(_react.default.Component), _defineProperty(_class3, "propTypes", {
  inputKey: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  percentage: _propTypes.default.bool,
  min: _propTypes.default.number.isRequired,
  max: _propTypes.default.number.isRequired,
  yearsToMonths: _propTypes.default.bool,
  eventName: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  suffix: _propTypes.default.string
}), _defineProperty(_class3, "defaultProps", {
  eventName: "UPDATE_LOAN_AND_ESTIMATE_MONTHLY_PAYMENT"
}), _defineProperty(_class3, "contextType", _ActionRoot.ActionRootContext), _class3), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "focused", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "parseDefaultValueFromProps", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "parseDefaultValueFromProps"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleKeyPress", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleKeyPress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleFocus", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleFocus"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleBlur", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleBlur"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleChange"), _class2.prototype)), _class2)) || _class;

var _default = RewardsCalculatorInput;
exports.default = _default;